import { render } from "./SurveyAnswersPage.vue?vue&type=template&id=fec9f966&scoped=true"
import script from "./SurveyAnswersPage.vue?vue&type=script&lang=js"
export * from "./SurveyAnswersPage.vue?vue&type=script&lang=js"

import "./SurveyAnswersPage.vue?vue&type=style&index=0&id=fec9f966&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fec9f966"]])

export default __exports__